module.exports = __webpack_public_path__ + "static/Onlay-1ad51a432a420a54f5fe146adbdf0566.jpg";